/** Row shape returned by `apiService.listPlaybooksForAgent` (archive order = Record N). */
export type PlaybookArchiveRow = {
  id: string;
  paragraph_text: string;
  paragraph_preview: string;
  filename: string;
  author: string;
  side?: string;
};

export type PlaybookRecordIndex = {
  byNumber: Map<number, PlaybookArchiveRow>;
  maxNumber: number;
};

/** 1-based record numbers match `--- Record N ---` headers in playbook context. */
export function buildPlaybookRecordIndex(rows: PlaybookArchiveRow[]): PlaybookRecordIndex {
  const byNumber = new Map<number, PlaybookArchiveRow>();
  rows.forEach((row, i) => {
    byNumber.set(i + 1, row);
  });
  return { byNumber, maxNumber: rows.length };
}

export function getPlaybookRecord(
  index: PlaybookRecordIndex,
  recordNum: number,
): PlaybookArchiveRow | undefined {
  return index.byNumber.get(recordNum);
}
